/**
 * @deprecated SSR IS DEPRECATED
 */
export const SUPPORT_FRESNEL_SSR = false
